export const eventsConstants = {
  EVENTS_INIT: '[Events] init',
  EVENTS_UPDATE: '[Events] Update',
  EVENTS_REMOVE: '[Events] Remove'
}
